export default "__VITE_ASSET__7a7417ee__"